'use client';
import {Box} from '@mui/material';
import Container from '@mui/material/Container';
import {styled} from '@mui/material/styles';
import {MapPanel, type MapPanelProps} from '../../map';
import {Section} from '../../primitives';
import {type NearbyPlaceRowProps} from '../NearbyPlaceRow';
import {NearbyPlacesList} from './NearbyPlacesList';

export interface NearbySectionProps {
  places: NearbyPlaceRowProps[];
  map: MapPanelProps;
  onViewAll?: () => void;
}

const MapColumn = styled(Box)(({theme}) => ({
  order: 1,
  [theme.breakpoints.up('md')]: {order: 2},
}));

export function NearbySection({places, map, onViewAll}: NearbySectionProps) {
  if (places.length === 0) {
    return null;
  }
  return (
    <Section sx={{backgroundColor: theme => theme.palette.colors.surface.section.emphasis}}>
      <Container
        sx={{
          display: 'grid',
          gridTemplateColumns: {xs: '1fr', md: 'minmax(0, 1fr) minmax(0, 1fr)'},
          rowGap: {xs: 2, md: 6},
          columnGap: 6,
          alignItems: {md: 'start'},
        }}
      >
        <NearbyPlacesList places={places} onViewAll={onViewAll} />
        <MapColumn>
          <MapPanel {...map} />
        </MapColumn>
      </Container>
    </Section>
  );
}

NearbySection.displayName = 'NearbySection';
